import {
  getDditList,
  getDailyDutiesTemplate,
  importDailyDuties,
} from "@ckweb/ckfetch/connectables/taskListManagement";

const FETCH_ID = "DailyDuties";

export const useGetDailyDutiesTemplate = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}Template`, getDailyDutiesTemplate, {
    fetchType: "download",
    showGlobalLoadingIndicator: true,
  });

export const useGetDailyDutiesForImport = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}`, getDditList, {
    fallback: [],
  });

export const useSubmitDailyDuties = () =>
  useSafeLocalFetch(`import${FETCH_ID}`, importDailyDuties, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });
